enum CaseType {
  Case = 'Case',
  Repair = 'Repair',
  InsuranceClaim = 'InsuranceClaim',
  Complaint = 'Complaint',
  Sales = 'Sales',
}

export default CaseType;
